module.exports = __webpack_public_path__ + "img/Mikolaj.c4243d63.jpg";